import { render, staticRenderFns } from "./pmc-supplier.vue?vue&type=template&id=489ca623"
import script from "./pmc-supplier.vue?vue&type=script&lang=ts"
export * from "./pmc-supplier.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports